module.exports = __webpack_public_path__ + "static/media/SVID_S_4-1.c19d64b7.png";